export const WRAPPER_CLICK = 'onWrapperClick'

export const USER_MENU_REGISTER = 'onUserMenuRegister'

export const USER_MENU_DESTROY = 'onUserMenuDestroy'



// WEBPACK FOOTER //
// ./src/components/Layout/EventKeys.js